// extracted by mini-css-extract-plugin
export var component = "heading-module--component--1xN41";
export var title = "heading-module--title--3YApw";
export var hr = "heading-module--hr--1_BhP";
export var light = "heading-module--light--18n8l";
export var surtitle = "heading-module--surtitle--3Vssa";
export var subtitle = "heading-module--subtitle--3mDs_";
export var half = "heading-module--half--2rQUH";